import { Box, Grid, Typography } from "@mui/material";
import image from "../../img/image.png";

export default function EmptyDashboard() {
  return (
    <Grid container spacing={0} direction="column" alignItems="center" justifyContent="center" paddingTop={4}>
      <Box display={"flex"} flexDirection={"column"}>
        <Box
          component="img"
          sx={{
            height: 400,
            width: 600,
          }}
          src={image}
        />
        <Typography variant="h6" align="center">
          You don't have pending activities
        </Typography>
      </Box>
    </Grid>
  );
}
